export default __webpack_public_path__ + "static/media/dashboard_prices.e44a323c.png";